module.exports = __webpack_public_path__ + "static/article-image-63f6916385f985b304424ff4584c4129.png";